import { systemEngineEnvironment } from "services/environment/systemEngine";

export const getUserByLogin = async (loginName: string) => {
  const sql = `select user_name, default_engine, default_database, login_name, service_account_name from information_schema.users where LOWER(login_name) = LOWER(?)`;

  const result = await systemEngineEnvironment.execute<{
    userName: string;
    defaultEngine: string | null;
    defaultDatabase: string | null;
    loginName: string | null;
    serviceAccountName: string | null;
  }>(sql, {
    parameters: [loginName],
  });

  const [response] = result;
  const rows = response.rows;
  return rows[0];
};
